import {Input, Output, EventEmitter, Component, LOCALE_ID, Inject, OnInit} from '@angular/core';
import {IntlService, CldrIntlService} from '@progress/kendo-angular-intl';

/*##################################################################################*
 * COMPOSANT SPRO : spro-calendar
 *
 * DESCRIPTION : Affichage d'un bouton qui ouvre un calendrier
 *
 ##################################################################################*/

@Component({
  selector: 'spro-calendar',
  templateUrl: './spro-calendar.component.html',
})
export class spro_cls_calendar implements OnInit {

  /** Date courante */
  @Input() d_date: Date;
  /** Afficher/Masquer le libellé de date */
  @Input() f_affLib: Boolean = false;
  /** Afficher/Masquer le bouton de choix de date */
  @Input() f_affBt: Boolean = true;
  /** Format d'affichage du libellé de date (si pas de paramètre w_lang fournit) */
  @Input() w_format: string = 'dd/MM/yyyy';
  /** Langue courante, pour formater la date en texte plein */
  @Input() w_lang: string = null;
  /** Pour désactiver le bouton */
  @Input() f_actif: boolean = true;


  /** Evénement sur changement de date */
  @Output() e_change: EventEmitter<any> = new EventEmitter();

  /** Afficher/Masquer la popup calendar */
  public f_show_calendar: boolean = false;

  /**
   * Constructeur
   */
  constructor(
    @Inject(LOCALE_ID) public localeId: string,
    public s_intl: IntlService) {
  }

  /**
   * ngOnInit
   */
  ngOnInit() {
    if (this.w_lang != null)
      this.proc_setLanguage(this.w_lang);
  }

  /*
   * Affectation de la langue utilisé pour la traduction du libellé de date
   */
  public proc_setLanguage(lang): void {
    this.localeId = lang;
    (<CldrIntlService>this.s_intl).localeId = lang;
  }

  /**
   * Affiche/masque la popup calendar
   */
  public proc_ouvre_calendar(): void {
    this.f_show_calendar = !this.f_show_calendar;
  }

  /**
   * Changement de la date de visu depuis le calendrier
   */
  public proc_change_date(value: Date): void {
    this.d_date = value;
    this.d_date.setHours(12)
    this.d_date.setMinutes(0);
    this.d_date.setSeconds(0);
    this.d_date.setMilliseconds(0);
    this.f_show_calendar = false;
    this.e_change.emit(this.d_date);
  }

  /**
   * Retourne le libellé de la date
   */
  public proc_get_lb_date(): string {
    if (this.w_lang == null)
      return this.s_intl.formatDate(this.d_date, this.w_format);
    else
      return this.s_intl.formatDate(this.d_date, "EEEE dd MMMM yyyy", this.w_lang);
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/inputs/spro-calendar/spro-calendar.component.ts